// extracted by mini-css-extract-plugin
export default {"root":"EcuOgysjlWEa7YvS9Y3S","day":"zzz7K2EBfixo9aqYtxLA"};